/**
 * Enums de transporte
 * Enumeraciones relacionadas con transportes y logística
 */

export enum TransportPrincipalType {
    SIMPLE_MOVEMENT = 'SIMPLE_MOVEMENT',
    PICKUP_TO_FINAL_CUSTOMER = 'PICKUP_TO_FINAL_CUSTOMER',
    DELIVERY_TO_FINAL_CUSTOMER = 'DELIVERY_TO_FINAL_CUSTOMER',
    PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER = 'PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER',
    WITH_STOPOVER = 'WITH_STOPOVER'
}

export const transportPrincipalTypeDescriptions: Record<TransportPrincipalType, string> = {
    [TransportPrincipalType.SIMPLE_MOVEMENT]: 'transportPrincipalType.SIMPLE_MOVEMENT',
    [TransportPrincipalType.PICKUP_TO_FINAL_CUSTOMER]: 'transportPrincipalType.PICKUP_TO_FINAL_CUSTOMER',
    [TransportPrincipalType.DELIVERY_TO_FINAL_CUSTOMER]: 'transportPrincipalType.DELIVERY_TO_FINAL_CUSTOMER',
    [TransportPrincipalType.PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER]: 'transportPrincipalType.PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER',
    [TransportPrincipalType.WITH_STOPOVER]: 'transportPrincipalType.WITH_STOPOVER'
};

export enum TransportStatus {
    PENDING = 'PENDING',
    PLANIFIED = 'PLANIFIED',
    IN_COURSE = 'IN_COURSE',
    FINISHED = 'FINISHED',
    CANCELLED = 'CANCELLED',
    DELETED = 'DELETED',
    EXPIRED = 'EXPIRED',
    DELIVERED = 'DELIVERED',
    COLLECTED = 'COLLECTED',
    IN_STOPOVER = 'IN_STOPOVER',
    UNASSIGNED = 'UNASSIGNED'
}

export const transportStatusDescriptions: Record<TransportStatus, string> = {
    [TransportStatus.PENDING]: 'transportStatus.PENDING',
    [TransportStatus.PLANIFIED]: 'transportStatus.PLANIFIED',
    [TransportStatus.IN_COURSE]: 'transportStatus.IN_COURSE',
    [TransportStatus.FINISHED]: 'transportStatus.FINISHED',
    [TransportStatus.CANCELLED]: 'transportStatus.CANCELLED',
    [TransportStatus.DELETED]: 'transportStatus.DELETED',
    [TransportStatus.EXPIRED]: 'transportStatus.EXPIRED',
    [TransportStatus.DELIVERED]: 'transportStatus.DELIVERED',
    [TransportStatus.COLLECTED]: 'transportStatus.COLLECTED',
    [TransportStatus.IN_STOPOVER]: 'transportStatus.IN_STOPOVER',
    [TransportStatus.UNASSIGNED]: 'transportStatus.UNASSIGNED'
};

export enum CancelledReason {
    VEHICLE_NOT_AVAILABLE = 'VEHICLE_NOT_AVAILABLE',
    VEHICLE_NOT_READY_AT_DEPARTURE = 'VEHICLE_NOT_READY_AT_DEPARTURE',
    VEHICLE_NOT_WORKING = 'VEHICLE_NOT_WORKING',
    MISSING_MANDATORY_SAFETY_EQUIPMENT = 'MISSING_MANDATORY_SAFETY_EQUIPMENT',
    INCORRECT_LICENSE_PLATE = 'INCORRECT_LICENSE_PLATE',
    BREAKDOWN_DURING_TRANSPORT = 'BREAKDOWN_DURING_TRANSPORT',
    ACCIDENT_DURING_TRANSPORT = 'ACCIDENT_DURING_TRANSPORT',
    VEHICLE_REJECTED_AT_ARRIVAL = 'VEHICLE_REJECTED_AT_ARRIVAL',
    VEHICLE_REJECTED_NO_APPOINTMENT_AT_DEPOT = 'VEHICLE_REJECTED_NO_APPOINTMENT_AT_DEPOT',
    RETURN_REJECTED = 'RETURN_REJECTED',
    END_CUSTOMER_REQUEST = 'END_CUSTOMER_REQUEST',
    CUSTOMER_REQUEST = 'CUSTOMER_REQUEST',
    CANCELLATION_DUE_TO_DRIVER_RESERVATION_CANCELLED = 'CANCELLATION_DUE_TO_DRIVER_RESERVATION_CANCELLED',
    RETURN_CANCELLED_DUE_TO_OUTBOUND_CANCELLATION = 'RETURN_CANCELLED_DUE_TO_OUTBOUND_CANCELLATION',
    CONTACT_ABSENT_AT_DEPARTURE = 'CONTACT_ABSENT_AT_DEPARTURE',
    CONTACT_ABSENT_AT_ARRIVAL = 'CONTACT_ABSENT_AT_ARRIVAL',
    UNREACHABLE_CONTACT_AT_START = 'UNREACHABLE_CONTACT_AT_START',
    UNREACHABLE_CONTACT_AT_ARRIVAL = 'UNREACHABLE_CONTACT_AT_ARRIVAL',
    NO_APPOINTMENT_POSSIBLE_WITH_END_CUSTOMER = 'NO_APPOINTMENT_POSSIBLE_WITH_END_CUSTOMER',
    NO_APPOINTMENT_WITH_ARRIVAL_CONTACT = 'NO_APPOINTMENT_WITH_ARRIVAL_CONTACT',
    DUPLICATE = 'DUPLICATE',
    INCORRECT_PICKUP_ADDRESS = 'INCORRECT_PICKUP_ADDRESS',
    INCORRECT_DELIVERY_ADDRESS = 'INCORRECT_DELIVERY_ADDRESS',
    NON_COMPLIANT_TRANSPORT_REQUEST = 'NON_COMPLIANT_TRANSPORT_REQUEST',
    CANCELLATION_DUE_TO_CAPACITY = 'CANCELLATION_DUE_TO_CAPACITY',
    OTHER = 'OTHER'
}

export const cancelledReasonDescriptions: Record<CancelledReason, string> = {
    [CancelledReason.VEHICLE_NOT_AVAILABLE]: 'cancelledReason.VEHICLE_NOT_AVAILABLE',
    [CancelledReason.VEHICLE_NOT_READY_AT_DEPARTURE]: 'cancelledReason.VEHICLE_NOT_READY_AT_DEPARTURE',
    [CancelledReason.VEHICLE_NOT_WORKING]: 'cancelledReason.VEHICLE_NOT_WORKING',
    [CancelledReason.MISSING_MANDATORY_SAFETY_EQUIPMENT]: 'cancelledReason.MISSING_MANDATORY_SAFETY_EQUIPMENT',
    [CancelledReason.INCORRECT_LICENSE_PLATE]: 'cancelledReason.INCORRECT_LICENSE_PLATE',
    [CancelledReason.BREAKDOWN_DURING_TRANSPORT]: 'cancelledReason.BREAKDOWN_DURING_TRANSPORT',
    [CancelledReason.ACCIDENT_DURING_TRANSPORT]: 'cancelledReason.ACCIDENT_DURING_TRANSPORT',
    [CancelledReason.VEHICLE_REJECTED_AT_ARRIVAL]: 'cancelledReason.VEHICLE_REJECTED_AT_ARRIVAL',
    [CancelledReason.VEHICLE_REJECTED_NO_APPOINTMENT_AT_DEPOT]: 'cancelledReason.VEHICLE_REJECTED_NO_APPOINTMENT_AT_DEPOT',
    [CancelledReason.RETURN_REJECTED]: 'cancelledReason.RETURN_REJECTED',
    [CancelledReason.END_CUSTOMER_REQUEST]: 'cancelledReason.END_CUSTOMER_REQUEST',
    [CancelledReason.CUSTOMER_REQUEST]: 'cancelledReason.CUSTOMER_REQUEST',
    [CancelledReason.CANCELLATION_DUE_TO_DRIVER_RESERVATION_CANCELLED]: 'cancelledReason.CANCELLATION_DUE_TO_DRIVER_RESERVATION_CANCELLED',
    [CancelledReason.RETURN_CANCELLED_DUE_TO_OUTBOUND_CANCELLATION]: 'cancelledReason.RETURN_CANCELLED_DUE_TO_OUTBOUND_CANCELLATION',
    [CancelledReason.CONTACT_ABSENT_AT_DEPARTURE]: 'cancelledReason.CONTACT_ABSENT_AT_DEPARTURE',
    [CancelledReason.CONTACT_ABSENT_AT_ARRIVAL]: 'cancelledReason.CONTACT_ABSENT_AT_ARRIVAL',
    [CancelledReason.UNREACHABLE_CONTACT_AT_START]: 'cancelledReason.UNREACHABLE_CONTACT_AT_START',
    [CancelledReason.UNREACHABLE_CONTACT_AT_ARRIVAL]: 'cancelledReason.UNREACHABLE_CONTACT_AT_ARRIVAL',
    [CancelledReason.NO_APPOINTMENT_POSSIBLE_WITH_END_CUSTOMER]: 'cancelledReason.NO_APPOINTMENT_POSSIBLE_WITH_END_CUSTOMER',
    [CancelledReason.NO_APPOINTMENT_WITH_ARRIVAL_CONTACT]: 'cancelledReason.NO_APPOINTMENT_WITH_ARRIVAL_CONTACT',
    [CancelledReason.DUPLICATE]: 'cancelledReason.DUPLICATE',
    [CancelledReason.INCORRECT_PICKUP_ADDRESS]: 'cancelledReason.INCORRECT_PICKUP_ADDRESS',
    [CancelledReason.INCORRECT_DELIVERY_ADDRESS]: 'cancelledReason.INCORRECT_DELIVERY_ADDRESS',
    [CancelledReason.NON_COMPLIANT_TRANSPORT_REQUEST]: 'cancelledReason.NON_COMPLIANT_TRANSPORT_REQUEST',
    [CancelledReason.CANCELLATION_DUE_TO_CAPACITY]: 'cancelledReason.CANCELLATION_DUE_TO_CAPACITY',
    [CancelledReason.OTHER]: 'cancelledReason.OTHER'
};

export enum LegPointType {
    ORIGIN = 'ORIGIN',
    STOPOVER = 'STOPOVER',
    STAGE = 'STAGE',
    DESTINATION = 'DESTINATION'
}

export const legPointTypeDescriptions: Record<LegPointType, string> = {
    [LegPointType.ORIGIN]: 'legPointType.ORIGIN',
    [LegPointType.STOPOVER]: 'legPointType.STOPOVER',
    [LegPointType.STAGE]: 'legPointType.STAGE',
    [LegPointType.DESTINATION]: 'legPointType.DESTINATION'
};

export enum ConnectionType {
    STOPOVER = 'STOPOVER',
    STAGE = 'STAGE'
}

export const connectionTypeDescriptions: Record<ConnectionType, string> = {
    [ConnectionType.STOPOVER]: 'connectionType.STOPOVER',
    [ConnectionType.STAGE]: 'connectionType.STAGE'
};

/**
 * Tipo de dirección
 */
export enum AddressType {
    CRANE_DEPOT = 'CRANE_DEPOT',
    DEALERSHIP = 'DEALERSHIP',
    ITV = 'ITV',
    PRIVATE = 'PRIVATE',
    REPAIR_SHOP = 'REPAIR_SHOP',
    VEHICLE_YARD = 'VEHICLE_YARD',
    WAREHOUSE = 'WAREHOUSE'
}

export const addressTypeDescriptions: Record<AddressType, string> = {
    [AddressType.CRANE_DEPOT]: 'addressType.CRANE_DEPOT',
    [AddressType.DEALERSHIP]: 'addressType.DEALERSHIP',
    [AddressType.ITV]: 'addressType.ITV',
    [AddressType.PRIVATE]: 'addressType.PRIVATE',
    [AddressType.REPAIR_SHOP]: 'addressType.REPAIR_SHOP',
    [AddressType.VEHICLE_YARD]: 'addressType.VEHICLE_YARD',
    [AddressType.WAREHOUSE]: 'addressType.WAREHOUSE'
};

/**
 * Tipos de ajuste para la cancelación
 */
export enum CancellationAdjustmentType {
    PAY = 'PAY',
    PENALTY = 'PENALTY',
    NO_PAY = 'NO_PAY'
}

export const cancellationAdjustmentTypeDescriptions: Record<CancellationAdjustmentType, string> = {
    [CancellationAdjustmentType.PAY]: 'cancellationAdjustmentType.PAY',
    [CancellationAdjustmentType.PENALTY]: 'cancellationAdjustmentType.PENALTY',
    [CancellationAdjustmentType.NO_PAY]: 'cancellationAdjustmentType.NO_PAY'
};

  export const statusColors: Record<string, { bg: string; text: string }> = {
    'PLANIFIED': { bg: '#FFF650', text: '#000000' },
    'IN_COURSE': { bg: '#419AE2', text: '#FFFFFF' },
    'FINISHED': { bg: '#7AD33B', text: '#000000' },
    'CANCELLED': { bg: '#F3273C', text: '#FFFFFF' },
    'DELETED': { bg: '#868686', text: '#FFFFFF' },
    'PENDING': { bg: '#FD977B', text: '#000000' },
    'DELIVERED': { bg: '#204D7C', text: '#FFFFFF' },
    'COLLECTED': { bg: '#419AE2', text: '#FFFFFF' },
    'EXPIRED': { bg: '#868686', text: '#FFFFFF' },
    'UNASSIGNED': { bg: '#868686', text: '#FFFFFF' }
  };


  export enum BudgetStatus {
  ACCEPTED = 'ACCEPTED',     // Aceptado
  REJECTED = 'REJECTED',     // Rechazado
  PENDING = 'PENDING',       // Pendiente
  CANCELLED = 'CANCELLED',   // Cancelado
  UNASSIGNED = 'UNASSIGNED'  // Anulado
}

export const budgetStatusDescriptions: Record<BudgetStatus, string> = {
    [BudgetStatus.ACCEPTED]: 'budgetStatus.ACCEPTED',
    [BudgetStatus.REJECTED]: 'budgetStatus.REJECTED',
    [BudgetStatus.PENDING]: 'budgetStatus.PENDING',
    [BudgetStatus.CANCELLED]: 'budgetStatus.CANCELLED',
    [BudgetStatus.UNASSIGNED]: 'budgetStatus.UNASSIGNED'
};


export enum AnomalyType {
    SCRATCH = 'SCRATCH',
    DENT = 'DENT',
    BREAK = 'BREAK',
    CHIP = 'CHIP',
    MISSING_ITEM = 'MISSING_ITEM',
    POOR_CONDITION = 'POOR_CONDITION',
    DIRTY = 'DIRTY'
}

export const anomalyTypeDescriptions: Record<AnomalyType, string> = {
    [AnomalyType.SCRATCH]: 'anomalyType.SCRATCH',
    [AnomalyType.DENT]: 'anomalyType.DENT',
    [AnomalyType.BREAK]: 'anomalyType.BREAK',
    [AnomalyType.CHIP]: 'anomalyType.CHIP',
    [AnomalyType.MISSING_ITEM]: 'anomalyType.MISSING_ITEM',
    [AnomalyType.POOR_CONDITION]: 'anomalyType.POOR_CONDITION',
    [AnomalyType.DIRTY]: 'anomalyType.DIRTY'
};

export enum AnomalyCategory {
    BODYWORK = 'BODYWORK',
    GLASS = 'GLASS',
    INTERIOR = 'INTERIOR',
    OTHER = 'OTHER'
}

export const anomalyCategoryDescriptions: Record<AnomalyCategory, string> = {
    [AnomalyCategory.BODYWORK]: 'anomalyCategory.BODYWORK',
    [AnomalyCategory.GLASS]: 'anomalyCategory.GLASS',
    [AnomalyCategory.INTERIOR]: 'anomalyCategory.INTERIOR',
    [AnomalyCategory.OTHER]: 'anomalyCategory.OTHER'
};
/**
 * Estados de la cita con cliente final
 */
export enum AppointmentStatus {
    PENDING = 'PENDING',
    BOOKED = 'BOOKED',
    EXPIRED = 'EXPIRED',
    CANCELLED = 'CANCELLED'
}

export const appointmentStatusDescriptions: Record<AppointmentStatus, string> = {
    [AppointmentStatus.PENDING]: 'appointmentStatus.PENDING',
    [AppointmentStatus.BOOKED]: 'appointmentStatus.BOOKED',
    [AppointmentStatus.EXPIRED]: 'appointmentStatus.EXPIRED',
    [AppointmentStatus.CANCELLED]: 'appointmentStatus.CANCELLED'
};

/**
 * Fases de cita
 */
export enum AppointmentPhase {
    PICKUP = 'PICKUP',
    DELIVERY = 'DELIVERY'
}

export const appointmentPhaseDescriptions: Record<AppointmentPhase, string> = {
    [AppointmentPhase.PICKUP]: 'appointmentPhase.PICKUP',
    [AppointmentPhase.DELIVERY]: 'appointmentPhase.DELIVERY'
};

/**
 * Quién concertó la cita
 */
export enum AppointmentBookedBy {
    FINAL_CUSTOMER = 'FINAL_CUSTOMER',
    ADMIN = 'ADMIN'
}

export const appointmentBookedByDescriptions: Record<AppointmentBookedBy, string> = {
    [AppointmentBookedBy.FINAL_CUSTOMER]: 'appointmentBookedBy.FINAL_CUSTOMER',
    [AppointmentBookedBy.ADMIN]: 'appointmentBookedBy.ADMIN'
};
